module.exports = __webpack_public_path__ + "static/media/hakeke-transparent.71e2bfb3.png";